<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div ref="chartContainer" style="width: 100%; height: 400px;" />
      </el-card>
    </template>
  </BasicLayout>

</template>

<script>
import echarts from 'echarts'
import { dateStrTodate } from '@/utils'

export default {
  name: 'TaskStat',
  props: {
    title: {
      type: String,
      default: '完成人数'
    },
    k: {
      type: String,
      default: 'task'
    }
  },
  data() {
    return {
      chart: {},
      option: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          text: this.title
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          data: [],
          x: 'center',
          y: 'bottom',
          padding: [10, 20, 10, 20] // 上、右、下、左的内边距
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '25%',
          containLabel: true
        },
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        }],
        toolbox: {
          show: true,
          feature: {}
        },
        tooltip: {
          trigger: 'axis',
          position: function(point) {
            const x = point[0]
            const y = '5%'// 向下移动 20 像素
            return [x, y]
          },
          formatter: function(params) {
            var tooltipContent = ''
            params.forEach(function(item) {
              if (item.value > 0) {
                tooltipContent += item.seriesName + ' : ' + item.value + '<br/>'
              }
            })
            return tooltipContent
          }
        },
        series: []
      }
    },
    refresh(data, taskType) {
      const time = []
      const dataArr = {}
      for (const i in data) {
        const val = data[i]
        time.push(dateStrTodate(val.date))
        for (const k in val[this.k]) {
          const taskVal = val[this.k][k]
          if (dataArr[k] === undefined) {
            dataArr[k] = []
          }
          dataArr[k].push(taskVal)
        }
      }

      this.option.xAxis.data = time
      for (const i in dataArr) {
        this.option.legend.data.push(taskType[i])
        const temp = {
          name: taskType[i],
          data: dataArr[i],
          type: 'line',
          smooth: true
        }
        this.option.series.push(temp)
      }
      this.chart.setOption(this.option, true)
    }
  }

}
</script>

<style scoped>

</style>
